import { Component, OnInit } from '@angular/core';
import {NgForm} from '@angular/forms';
import {AuthService} from '../../core/auth/auth.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

    constructor( private authService: AuthService, private router: Router ) { }

    ngOnInit() {
    }

}
 


// WEBPACK FOOTER //
// ./src/app/modules/home/home.component.ts